import React, { useEffect } from "react";
import liff from "@line/liff";
import Logo from "assets/images/png/logo.jpg";
import "./style.css";

export default function HomeContainer() {
  function onClickGotoLine() {
    liff.closeWindow();
  }

  return (
    <div className="home-container">
      <div>
        <div
          style={{
            borderRadius: "50%",
            backgroundColor: "white",
            width: 300,
            height: 300,
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img src={Logo} width={250} />
        </div>

        <center
          onClick={onClickGotoLine}
          style={{
            cursor: "pointer",
            fontSize: 20,
            fontWeight: "bold",
            marginTop: 20,
            background: "#06C755",
            color: "white",
            padding: 10,
            borderRadius: 15,
          }}
        >
          กลับสู่ Line
        </center>
      </div>
    </div>
  );
}
